import { parseInTz } from 'helpers/date';
import { constructURL } from 'helpers/url';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["recordsAjaxSelect"];

  dateTimeOfServiceChanged(event) {
    const dateOfService = parseInTz(event.target.value).format();
    const url = constructURL(this.recordsAjaxSelectTarget.getAttribute('src'), { date_of_service: dateOfService });
    this.recordsAjaxSelectTarget.setAttribute('src', url.toString());
    this.updateRecordsAjaxSelect();
  }

  patientChanged(event) {
    const patientID = event.target.value;
    const url = constructURL(this.recordsAjaxSelectTarget.getAttribute('src'), { patient_id: patientID });
    this.recordsAjaxSelectTarget.setAttribute('src', url.toString());
    this.updateRecordsAjaxSelect();
  }

  updateRecordsAjaxSelect() {
    const autocompleteSkilled = this.recordsAjaxSelectTarget;
    this.clearOptions('', autocompleteSkilled);
  }

  async clearOptions(options, autocomplete) {
    autocomplete.optionsContainer.innerHTML = options;
    autocomplete.reset();
    autocomplete.clear();
    autocomplete.combobox.stop();
    autocomplete.combobox.start();
    autocomplete.combobox.initializeOptions();
    autocomplete.selectVariant.start();
    autocomplete.searchVariant.search('');
    await autocomplete.reposition();
  }
}
